module.exports = __webpack_public_path__ + "img/tutorial04.0c73edba.png";